const headers = {
  name: "Project issues",
  navigate: {
    path: [
      {
        name: "Issues",
        path: "/app/projects/issues/",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
